import { Box, Chip } from "@mui/material";

export default function FailureLabel({ text }) {
  return (
    <Box className="w-full">
      <Chip
        className="chipContainer w-full"
        sx={{
          backgroundColor: "#F29396",
          color: "black",
          borderColor: "red",
          width: '100% !important;'
        }}
        label={text}
      />
    </Box>
  );
}
